import React from 'react'

import FlexGrid from '../structure/FlexGrid'

const ToRight = ({ children }) => <FlexGrid align="center" justify="flex-end" children={children} />

export default ToRight
